import { UnexpectedEventDetail } from '@/api/main/types.gen'

export type EventLocation = { latitude: number; longitude: number }

const averageOfPoints = (points: Array<{ latitude: number; longitude: number }>): EventLocation | undefined => {
  if (points.length === 0) return undefined
  const sum = points.reduce(
    (acc, p) => ({ latitude: acc.latitude + p.latitude, longitude: acc.longitude + p.longitude }),
    { latitude: 0, longitude: 0 }
  )
  return { latitude: sum.latitude / points.length, longitude: sum.longitude / points.length }
}

/**
 * Best-effort sanitized vehicle location for centring panels (mapy.cz, google maps,
 * navigation map, segments map). Falls back through patrol vehicle position →
 * current street segment midpoint → first future street segment first point.
 */
export const computeSanitizedLocation = (details: UnexpectedEventDetail): EventLocation | undefined => {
  const patrol = details.navigation_data?.patrol_vehicle
  if (
    patrol?.position?.latitude !== undefined &&
    patrol?.position?.longitude !== undefined &&
    patrol.position.latitude !== null &&
    patrol.position.longitude !== null
  ) {
    return { latitude: patrol.position.latitude, longitude: patrol.position.longitude }
  }

  const current = details.navigation_data?.current_street_segment
  if (current?.geom?.points?.length) {
    const avg = averageOfPoints(current.geom.points)
    if (avg) return avg
  }

  const future = details.navigation_data?.future_street_segments?.[0]
  if (future?.geom?.points?.length) {
    return future.geom.points[0]
  }

  return undefined
}
